import API from 'services/API';

export default function get2NDFL() {
  return API.request({
    method: 'GET',
    url: '/taxpayer/2ndfl/v2',
    mapper: function (responseData) {
      return responseData.map((item) => {
        item.companyName = item.companyName ? item.companyName.replace(/,+/g, ' ') : '';
        return item;
      });
    },
  });
}
